const graphData = [
      {
          name: 'Celebrities',
          engagementRate: 1.2
      },
      {
          name: 'Influencers',
          engagementRate: 1.6
      },
      {
          name: 'Brand Ambassadors',
          engagementRate: 5.8
      }
];

export default graphData;



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/engagement_rate_graph/engagement_rate_graph_info.js